module.exports = __webpack_public_path__ + "static/media/montagu_evans.fc01184a.jpg";